import BaseService from './BaseService';

class FateService extends BaseService {
  /**
   * Fetch
   * @return {Promise}
   */
  fetchFate = () => {
    const config = {
      url: '/fate',
    };
    return this.doRequest(config);
  };


  /**
   * Purchase Item
   * @param  {Object} data
   * @return {Promise}
   */
  purchaseItem = (data) => {
    const { storeItemId, newName = null, avatarImage = null } = data;
    const config = {
      method: 'post',
      url: '/fate/purchase',
      data: {
        storeItemId,
        newName,
        avatarImage,
      },
    };
    return this.doRequest(config);
  };

  changeAvatar = (avatarImage) => {
    const config = {
      method: 'post',
      url: '/fate/changeavatar',
      data:{avatarImage}
    };
    return this.doRequest(config);
  };
}

export { FateService as default };